import { render, staticRenderFns } from "./Localidades.vue?vue&type=template&id=0876a416"
import script from "./Localidades.vue?vue&type=script&lang=js"
export * from "./Localidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports